import axios from "axios";

import { CommisionProps } from "../../Commission";
import { restErrorHandler } from '../../../../helpers/restErrorHandler';


export const fetchCommissionData = (
    serialNumber: string, 
    role: string, 
    setData: (value: CommisionProps) => void
): void => {
    axios.get<CommisionProps>(
        `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v2/acb/${serialNumber}/commission`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var data: CommisionProps = response.data
            setData(data)
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
    });
}